export default function EmergencyPlanDirective() {
  return {
    template: require('./emergency-plan.html'),
    scope: {
      assessmentId: '=',
      status: '=',
      canEdit: '<',
    },
    controller: 'EmergencyPlanController',
    controllerAs: 'emergencyPlanVM',
    bindToController: true,
    replace: true,
  };
}
